"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "MapType", {
  enumerable: true,
  get: function get() {
    return _Storage.MapType;
  }
});
Object.defineProperty(exports, "PlainType", {
  enumerable: true,
  get: function get() {
    return _Storage.PlainType;
  }
});
Object.defineProperty(exports, "StorageFunctionModifier", {
  enumerable: true,
  get: function get() {
    return _Storage.StorageFunctionModifier;
  }
});
exports.StorageFunctionMetadata = exports.StorageFunctionType = exports.DoubleMapType = void 0;

var _util = require("@plugnet/util");

var _EnumType = _interopRequireDefault(require("../../codec/EnumType"));

var _Struct = _interopRequireDefault(require("../../codec/Struct"));

var _Vector = _interopRequireDefault(require("../../codec/Vector"));

var _Bytes = _interopRequireDefault(require("../../primitive/Bytes"));

var _Text = _interopRequireDefault(require("../../primitive/Text"));

var _Storage = require("../v2/Storage");

// Copyright 2017-2019 @polkadot/types authors & contributors
// This software may be modified and distributed under the terms
// of the Apache-2.0 license. See the LICENSE file for details.
// Re-export classes that haven't changed between V2 and V3
class DoubleMapType extends _Struct.default {
  constructor(value) {
    super({
      key1: _Text.default,
      key2: _Text.default,
      value: _Text.default,
      key2Hasher: _Text.default
    }, value);
  }
  /**
   * @description The mapped key as [[Text]]
   */


  get key1() {
    return this.get('key1');
  }
  /**
   * @description The mapped key as [[Text]]
   */


  get key2() {
    return this.get('key2');
  }
  /**
   * @description The hashing algorithm used to hash key2, as [[Text]]
   */


  get key2Hasher() {
    return this.get('key2Hasher');
  }
  /**
   * @description The mapped key as [[Text]]
   */


  get value() {
    return this.get('value');
  }

}

exports.DoubleMapType = DoubleMapType;

class StorageFunctionType extends _EnumType.default {
  constructor(value, index) {
    super({
      PlainType: _Storage.PlainType,
      MapType: _Storage.MapType,
      DoubleMapType
    }, value, index);
  }
  /**
   * @description The value as a mapped value
   */


  get asDoubleMap() {
    (0, _util.assert)(this.isDoubleMap, "Cannot convert '".concat(this.type, "' via asDoubleMap"));
    return this.value;
  }
  /**
   * @description The value as a mapped value
   */


  get asMap() {
    (0, _util.assert)(this.isMap, "Cannot convert '".concat(this.type, "' via asMap"));
    return this.value;
  }
  /**
   * @description The value as a [[Type]] value
   */


  get asType() {
    (0, _util.assert)(this.isPlainType, "Cannot convert '".concat(this.type, "' via asType"));
    return this.value;
  }
  /**
   * @description `true` if the storage entry is a doublemap
   */


  get isDoubleMap() {
    return this.toNumber() === 2;
  }
  /**
   * @description `true` if the storage entry is a map
   */


  get isMap() {
    return this.toNumber() === 1;
  }
  /**
   * @description `true` if the storage entry is a plain type
   */


  get isPlainType() {
    return this.toNumber() === 0;
  }
  /**
   * @description Returns the string representation of the value
   */


  toString() {
    if (this.isDoubleMap) {
      return this.asDoubleMap.toString();
    }

    if (this.isMap) {
      if (this.asMap.isLinked) {
        return "(".concat(this.asMap.value.toString(), ", Linkage<").concat(this.asMap.key.toString(), ">)");
      }

      return this.asMap.value.toString();
    }

    return this.asType.toString();
  }

}

exports.StorageFunctionType = StorageFunctionType;

/**
 * @name StorageFunctionMetadata
 * @description
 * The definition of a storage function
 */
class StorageFunctionMetadata extends _Struct.default {
  constructor(value) {
    super({
      name: _Text.default,
      modifier: _Storage.StorageFunctionModifier,
      type: StorageFunctionType,
      fallback: _Bytes.default,
      documentation: _Vector.default.with(_Text.default)
    }, value);
  }
  /**
   * @description The default value of the storage function
   * @deprecated Use `.fallback` instead.
   */


  get default() {
    return this.fallback;
  }
  /**
   * @description The [[Text]] documentation
   */


  get documentation() {
    return this.get('documentation');
  }
  /**
   * @description The [[Text]] documentation
   * @deprecated Use `.documentation` instead.
   */


  get docs() {
    return this.documentation;
  }
  /**
   * @description The [[Bytes]] fallback default
   */


  get fallback() {
    return this.get('fallback');
  }
  /**
   * @description The [[MetadataArgument]] for arguments
   */


  get modifier() {
    return this.get('modifier');
  }
  /**
   * @description The call name
   */


  get name() {
    return this.get('name');
  }
  /**
   * @description The [[StorageFunctionType]]
   */


  get type() {
    return this.get('type');
  }

}

exports.StorageFunctionMetadata = StorageFunctionMetadata;